import React, { useEffect } from 'react';

interface GoogleFontsLoaderProps {
  fontFamily?: string | null;
  variants?: string[];
}

const GoogleFontsLoader: React.FC<GoogleFontsLoaderProps> = ({
  fontFamily,
  variants = ['400', '500', '600', '700'],
}) => {
  useEffect(() => {
    if (!fontFamily) return;

    const existingLinks = document.querySelectorAll('link[data-google-font="true"]');
    existingLinks.forEach(link => link.remove());

    const link = document.createElement('link');
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(
      fontFamily
    )}:wght@${variants.join(';')}&display=swap`;
    link.rel = 'stylesheet';
    link.setAttribute('data-google-font', 'true');
    
    document.head.appendChild(link);

    const root = document.documentElement;
    root.style.setProperty('--font-family-primary', `'${fontFamily}', sans-serif`);

    return () => {
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
      root.style.removeProperty('--font-family-primary');
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
      root.style.removeProperty('--font-family-primary');
    };
  }, [fontFamily, variants]);

  return null;
};

export default GoogleFontsLoader;
